import { render } from "./PigeonDoc.vue?vue&type=template&id=14f90e87"
import script from "./PigeonDoc.vue?vue&type=script&lang=js"
export * from "./PigeonDoc.vue?vue&type=script&lang=js"

import "./PigeonDoc.vue?vue&type=style&index=0&id=14f90e87&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__